var exports = {
  "Z": "xfb577c5e--5ca9bf--layout",
};

module.exports = exports;
